import { BYSTADIUM_SITENAMES, STORES } from "@stadium/shared/src/constants/brands";

export const isStadiumSite = (site) => BYSTADIUM_SITENAMES.includes(site);
export const isStoreSite = (site) => STORES === site;
